<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.schools', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $tc('messages.grades', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 md:grid-cols-12">
                <div class="sm:col-span-4">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.domains', 1)" for="category_id" />
                        <FormSelect
                            id="category_id"
                            v-model="form.category_id"
                            :options="options.categories"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.category_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div>
            {{ $t('messages.avg_grade') }}

            <!--            <apexchart type="bar" height="350"-->
            <!--                       :series="schoolsChart.series"-->
            <!--                       :options="schoolsChart"-->
            <!--            >-->
            <!--            </apexchart>-->

            <div>
                <GradesBarGraphSortable :input-series="schoolsChart.series[0]" :input-options="schoolsChart" />
            </div>
        </div>

        <div>
            <span
                v-for="(annotation, index) in annotations"
                :key="index"
                class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
                :class="[annotation['bg-color'], annotation['text-color']]"
            >
                {{ annotation.key }}: {{ annotation.value.toFixed(2) }}
            </span>
        </div>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormError from '@/components/Forms/FormError.vue';
import GradesBarGraphSortable from '@/components/pageSpecific/GradesBarGraphSortable.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        FormLabel,
        FormSelect,
        FormError,
        GradesBarGraphSortable,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'schools', 'filters', 'options', 'subjects', 'schoolsChart', 'annotations'],
    data() {
        return {
            form: this.$inertia.form({
                category_id: this.filters.category_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
